import React, { useState } from 'react';
import LessonCard from 'Components/LessonCard';
import useTranslation from 'Hooks/useTranslation';
import useRoute from '../../Hooks/useRoute';
import { ModuleContainer, Title, seeAllText, CollapsedLessonContainer, ExpandedLessonContainer } from './style';

export default function Module({ title, lessons, modules, course, moduleId }) {
  const { t2 } = useTranslation('CourseDetails');
  const [expanded, setExpanded] = useState(false);
  const { sendToLessons } = useRoute();

  const mappedLessons = lessons?.map(lesson => (
    <LessonCard
      key={lesson.id}
      lesson={lesson}
      moduleId={moduleId}
      clickEvent={() => {
        sendToLessons(lesson, modules, course);
      }}
    />
  ));

  return (
    <ModuleContainer>
      <div style={Title}>{title}</div>
      {expanded ? (
        <ExpandedLessonContainer>{mappedLessons}</ExpandedLessonContainer>
      ) : (
        <CollapsedLessonContainer>{mappedLessons}</CollapsedLessonContainer>
      )}
      {lessons && lessons.length >= 3 ? (
        <div style={seeAllText} onClick={() => setExpanded(!expanded)} onKeyDown={() => {}} role="button" tabIndex={0}>
          {expanded ? t2('ViewLess') : t2('ViewAll')}
        </div>
      ) : null}
    </ModuleContainer>
  );
}
